import { createRouter, createWebHistory } from 'vue-router'
import Init from '@/views/Init/InitView.vue'
import Home from '@/views/Home/HomeView.vue'
import Guide from '@/views/Guide/GuideView.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy/PrivacyPolicyView.vue'
import TermsOfService from '@/views/TermsOfService/TermsOfServiceView.vue'

const routes = [
  {
    path: '/',
    name: 'Init',
    component: Init
  },{
    path: '/Home',
    name: 'Home',
    component: Home
  },{
    path: '/Guide',
    name: 'Guide',
    component: Guide
  },{
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },{
    path: '/TermsOfService',
    name: 'TermsOfService',
    component: TermsOfService
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
